import moment from "moment";

export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const formatDate = (date: any) =>
  moment(date).format("YYYY-MM-DDTHH:mm:ss");
